import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { authInterceptorFn } from './interceptors';

@NgModule({
    declarations: [],
    exports: [],
    imports: [],
    providers: [provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptorFn]))],
})
export class BaseflowAuthModule {}
